import _ from "lodash";

export const router = (path: any) => {
  const base = window.location.origin;
  window.location.href = `${base}${path}`;
};

export const generatePaymentLinkCheckout = (shortCode: string) => {
  const base = window.location.origin;
  return `${base}/p/${shortCode}`;
};

export function formatBoolean(value: boolean) {
  return value ? "Yes" : "No";
}
// Helper function to recursively print nested objects
export function printNested(
  obj: any,
  exclude?: string[],
  valueCallback?: (val: string) => any,
  include?: string[]
): any[] {
  const result = [];
  for (const key in obj) {
    if (exclude?.includes(key) || (include && !include.includes(key))) {
      continue;
    }
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];

      if (_.isObject(value)) {
        result.push(...printNested(value, exclude, valueCallback, include));
      } else if (_.isArray(value)) {
        for (const item of value) {
          if (_.isObject(item)) {
            result.push(...printNested(item, exclude, valueCallback, include));
          } else {
            result.push({
              label: _.startCase(key),
              value: valueCallback?.(item) ?? item,
            });
          }
        }
      } else {
        const formattedValue = _.isBoolean(value)
          ? formatBoolean(value)
          : _.isNil(value) || _.isEmpty(value)
            ? "N/A"
            : value;
        result.push({
          label: _.startCase(key),
          value: valueCallback?.(formattedValue) ?? formattedValue,
        });
      }
    }
  }
  return result;
}
